import React from "react";
import "./ModalVideos.css";
import Modal from "../../UI/Modal/Modal";
import { Close } from "../Svgs/SVGs";
import { prefix } from "../../../scripts/helpers/constants";

const modalVideos = props => {
  return (
    <Modal show={props.show} modalClosed={props.modalClosed}>
      {props.show ? (
        <div className={prefix + "-c-header-video-close-icon-main"}>
          <a
            className="header-video-close-icon-link"
            onClick={props.modalClosed}
          >
            <Close reference="svg-icon header-video-close-icon" />
          </a>
          <iframe
            title="Main"
            src={
              "https://player.vimeo.com/video/" +
              props.videoCode +
              "?title=0&byline=0&portrait=0&playsinline=0"
            }
            className={
              window.innerWidth < 768 ? "video-modal-mobile" : "video-modal"
            }
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen="true"
          />
        </div>
      ) : null}
    </Modal>
  );
};

export default modalVideos;



// WEBPACK FOOTER //
// ./src/components/General/ModalVideos/ModalVideos.js